import React from 'react'

export default function UserInfo (props) {
  return (
    <svg x='0px' y='0px' width='16px' height='16px' viewBox='0 0 16 16' {...props}>
      <g>
        <path fill='currentColor' d='M15,0H1C0.4,0,0,0.4,0,1v14c0,0.6,0.4,1,1,1h14c0.6,0,1-0.4,1-1V1C16,0.4,15.6,0,15,0z M14,14H2V2h12V14z' />
        <rect data-color='color-2' x={4} y={5} fill='currentColor' width={8} height={2} />
        <rect data-color='color-2' x={4} y={9} fill='currentColor' width={8} height={2} />
      </g>
    </svg>
  )
}



// WEBPACK FOOTER //
// ./components/Customers/icons/user-info.js